import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { ProductService } from '@services/product.service';
import { Product } from '@models/product';
import { Title } from '@angular/platform-browser';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'gob-product-page',
  templateUrl: './product-page.component.html',
  styleUrls: ['./product-page.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProductPageComponent implements OnInit {
  loading: boolean=false;
  product: Product;
  indImg: number=0;

  constructor(
    private router: ActivatedRoute,
    private pServ: ProductService,
    private title: Title,
    private meta: Meta
  ) {
    this.loading=true;
    this.product=new Product();
    this.router.paramMap
      .pipe(
        switchMap(params => this.pServ.getProduct(params.get('id')))
      )
      .subscribe(product => {
        this.product=product;
        this.title.setTitle(product.name);
        this.meta.addTag({name: 'description', content: product.subtitle});
        this.loading=false;
      });
  }

  ngOnInit(): void {
  }
}
